(() => {
  const PREFILL_KEY = 'explora_signup_email_prefill';
  const TOGGLE_ID = 'cart-explora-toggle';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const toggle = event.target.closest(`#${TOGGLE_ID}`);
    if (toggle) {
      toggle.nextElementSibling?.classList.add('active');
      toggle.setAttribute('aria-expanded', 'true');
      return;
    }

    if (!event.target.closest('.order-note-toggle__content-overlay')) return;

    const panel = event.target.closest('.cart-explora-toggle__content');
    if (!panel) return;

    panel.classList.remove('active');
    document.getElementById(TOGGLE_ID)?.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.hasAttribute('data-cart-explora-form')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const emailInput = form.querySelector('input[type="email"]');
      const termsInput = form.querySelector('.signup-container--terms input[type="checkbox"]');

      if (!emailInput?.checkValidity()) {
        emailInput?.reportValidity();
        return;
      }

      if (termsInput && !termsInput.checkValidity()) {
        termsInput.reportValidity();
        return;
      }

      try {
        sessionStorage.setItem(PREFILL_KEY, emailInput.value.trim());
      } catch (e) {}

      const url = new URL(form.getAttribute('action'), window.location.origin);
      const source = form.elements.source?.value;
      const sourceTemplate = document.body.dataset.template;
      if (source) url.searchParams.set('source', source);
      if (sourceTemplate) url.searchParams.set('source_template', sourceTemplate);

      window.location.assign(url.toString());
    },
    true
  );
})();
